export default "__VITE_ASSET__pavJCr7o__"